var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.title) + " "),
          _c("w-spacer"),
          _vm._t("actions"),
        ],
        2
      ),
      _c(
        "w-list",
        _vm._l(_vm.browses, function (browse, i) {
          return _c(
            "w-list-item",
            {
              key: i,
              staticClass: "item",
              attrs: { disabled: !_vm.canEditViews(browse) },
              on: {
                click: function ($event) {
                  return _vm.onBrowseClick(browse)
                },
              },
            },
            [
              _c(
                "w-list-item-icon",
                [
                  !_vm.canEditViews(browse)
                    ? _c("w-fa", {
                        staticClass: "lock",
                        attrs: { icon: "lock" },
                      })
                    : _c("div", { class: _vm.getIconClass(browse) }),
                ],
                1
              ),
              _c("w-list-item-text", [
                _vm._v(
                  " " +
                    _vm._s(browse.Name.getTranslation(_vm.$i18n.locale)) +
                    " "
                ),
              ]),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }